import React, { useEffect, useRef, useState } from 'react'
import { IDataDisplayerItem, IDataDisplyerItemActionOption } from './DataDisplayer'
import { useDispatch } from 'react-redux'
import { toggleDisplayerColumn } from './dataDisplyerSlice'
import { Button } from '@mui/material'
import GenerateIcon from '../GenerateIcon'
import { Link, useNavigate } from 'react-router-dom'
import { replaceItemDataInLink } from '../../features/BaseApp'

interface IProps {
    item: IDataDisplayerItem,
    isShown?: boolean,
    hideModal: () => void,
    itemActionOptions: Array<IDataDisplyerItemActionOption>,
    handleDeleteItem: (id: number) => void,
}

export default function DisplayerItemOptions(props: IProps) {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { isShown, hideModal, itemActionOptions, item, handleDeleteItem } = props

    const baseContainerClassName: string = "data-displayer-options-modal item-options"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    const menuRef = useRef<HTMLDivElement | null>(null);
  
    // Close menu if clicked outside
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            hideModal()
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    useEffect(() => {
        if (isShown){
            setContainerClassName(baseContainerClassName + " active")
        }else{
            setContainerClassName(baseContainerClassName)
        }
    }, [isShown])

    return(
        <div className={containerClassName} ref={menuRef}>
            <div className="content-of-data-displayer-options-modal">
                
                {itemActionOptions.map((option, index: number) => {

                    return(
                        <div className="item-of-data-displayer-options-modal" key={index}>
                            <div className="content-of-item-of-data-displayer-options-modal">
                                <Button onClick={() => option.link ? navigate(replaceItemDataInLink(option.link, item)) : option.onClick(item.rawItem)} fullWidth startIcon={<GenerateIcon icon={option.icon} />} className="general-button admin-style">{option.label}</Button>
                            </div>
                        </div>
                    )
                })}

                <div className="item-of-data-displayer-options-modal">
                    <div className="content-of-item-of-data-displayer-options-modal">
                        <Button onClick={() => {
                            hideModal()
                            handleDeleteItem(item.rawItem.id)
                        }} fullWidth startIcon={<GenerateIcon icon="delete" />} color="error" className="general-button admin-style">Delete</Button>
                    </div>
                </div>

            </div>
        </div>
    )
}